import styled from "styled-components";
import { variant } from "styled-system";
import css from "@styled-system/css";

import { ProgressProps } from "./progressBar.type";

import variants from "./variants";

const ProgressBar = styled.div<ProgressProps>`
  height: 10px;
  animation: load 3s normal forwards;
  width: ${(props) => props.progress}%;
  max-width: 100%;

  @keyframes load {
    0% {
      width: 0;
    }
    100% {
      width: ${(props) => props.progress}%;
    }
  }
  ${css({
    backgroundColor: "progress-bar-fill-color",
  })}
  ${variant({ variants })}
`;

const ProgressIndicator = ({ progress, variant }: ProgressProps) => {
  return (
    <ProgressBar
      progress={progress}
      variant={variant}
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
    />
  );
};

export default ProgressIndicator;
